var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleSwitch',{model:{value:(_vm.isOxide),callback:function ($$v) {_vm.isOxide=$$v},expression:"isOxide"}},[_c('IxRes',[_vm._v("Areas.FieldRecordSystem.SR_BaseFertilization.OxideForm")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }